module.exports = __webpack_public_path__ + "assets/img/my-news-desk.4f3af475.png";